import React from 'react';
import { SectorPageTemplate } from '../components/SectorPageTemplate';
export function SectorLokaleRetailPage() {
  return <SectorPageTemplate sectorName="Lokale Retail & Dienstverlening" sectorSlug="lokale-retail" heroTitle="Webdesign voor lokale winkels en dienstverleners" heroDescription="Professionele websites voor kapsalons, garages, fietsenmakers en andere lokale ondernemers. Wij bouwen websites die klanten uit de buurt aantrekken." whyTitle="Waarom een goede website essentieel is voor lokale ondernemers" whyDescription="Mensen zoeken lokaal naar diensten en producten. Zorg dat jouw zaak als eerste naar voren komt in Google." whyItems={[{
    icon: 'SearchIcon',
    title: 'Lokaal vindbaar',
    description: 'Word gevonden door mensen in jouw stad of dorp die zoeken naar jouw specifieke diensten.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Afspraken online',
    description: 'Laat klanten 24/7 online een afspraak inplannen voor een knipbeurt, APK of reparatie.'
  }, {
    icon: 'MapPinIcon',
    title: 'Openingstijden & Route',
    description: 'Zorg dat essentiële informatie zoals openingstijden en locatie direct zichtbaar is op mobiel.'
  }, {
    icon: 'StarIcon',
    title: 'Reviews tonen',
    description: 'Bouw vertrouwen op door ervaringen van tevreden klanten uit de buurt te laten zien.'
  }]} features={[{
    icon: 'CalendarCheckIcon',
    title: 'Boekingssysteem',
    description: 'Een geïntegreerd systeem of koppeling met jouw bestaande planningssoftware.'
  }, {
    icon: 'PhoneIcon',
    title: 'Click-to-call',
    description: 'Een opvallende bel-knop voor mobiele bezoekers die direct een vraag hebben.'
  }, {
    icon: 'MapPinIcon',
    title: 'Google Maps integratie',
    description: 'Een interactieve kaart zodat klanten direct de route naar jouw zaak kunnen plannen.'
  }]} clusters={[{
    name: 'Kapsalon',
    slug: 'kapsalon',
    label: 'Beauty',
    description: 'Websites voor kapsalons en schoonheidssalons met online boeken.'
  }, {
    name: 'Fietsenwinkel',
    slug: 'fietsenwinkel',
    label: 'Retail',
    description: 'Websites voor fietsenmakers met focus op reparaties en verkoop.'
  }, {
    name: 'Garage',
    slug: 'garage',
    label: 'Automotive',
    description: 'Websites voor autogarages met APK-planner en dienstenoverzicht.'
  }, {
    name: 'Autobedrijf',
    slug: 'autobedrijf',
    label: 'Occasions',
    description: 'Websites voor autodealers met occasion-aanbod en inruilmodule.'
  }]} faqs={[{
    q: 'Hoe zorg ik dat ik bovenaan in Google Maps kom?',
    a: 'Wij optimaliseren je website voor lokale SEO en helpen je met het inrichten van een sterk Google Bedrijfsprofiel, wat cruciaal is voor lokale vindbaarheid.'
  }, {
    q: 'Kan ik mijn bestaande afsprakensysteem behouden?',
    a: 'Ja, we kunnen vrijwel elk bestaand boekingssysteem (zoals Salonized voor kappers) netjes integreren in je nieuwe website.'
  }, {
    q: 'Wat kost een website voor een lokale winkel?',
    a: 'Een professionele, lokaal geoptimaliseerde website start vanaf €1.500. Wil je ook een webshop toevoegen, dan maken we een offerte op maat.'
  }, {
    q: 'Is de website makkelijk aan te passen?',
    a: "Zeker. Je kunt zelf eenvoudig openingstijden aanpassen voor feestdagen, nieuwe acties toevoegen of foto's van je zaak updaten."
  }]} relatedPages={[{
    name: 'Website laten maken',
    href: '#/website-laten-maken'
  }, {
    name: 'SEO voor websites',
    href: '#/seo-voor-websites'
  }]} data-id="element-1882" />;
}